import { Component, Input } from '@angular/core';
import {
  IDates,
  IOdbCoverDetailDivisionSummaryCategories,
  coverService,
} from '@dch/billing-business-logic';

import { TranslationService } from '@dch/ng-common';

@Component({
  selector: 'my-bill-odb-category-details-identifier',
  templateUrl: './odb-category-details-identifier.component.html',
  standalone: false,
})
export class OdbCategoryDetailsIdentifierComponent {
  @Input() validFor?: IDates;
  @Input() category?: keyof IOdbCoverDetailDivisionSummaryCategories;

  get duration() {
    return coverService.getCategoryDetailDisplayableDuration(
      this.validFor,
      this.category,
      (key) => this.translationService.getTranslatedValueFor(key)
    );
  }

  constructor(private translationService: TranslationService) {}
}
